import { useIntl } from "react-intl";

import ImageUrlField from "./ImageUrlField";
import ListBooleanField from "./ListBooleanField";
import ListFieldHint from "./ListFieldHint";
import ListFieldTitle from "./ListFieldTitle";
import ListIconField from "./ListIconField";
import ListRecordField from "./ListRecordField";
import ListTextControl from "./ListTextControl";

function ListField({ field, value, onChange }) {
  const intl = useIntl();
  const placeholder = field.example
    ? intl.formatMessage({ id: field.example })
    : undefined;

  if (field.type === "image") {
    return (
      <ImageUrlField
        label={field.label}
        value={value}
        size={field.size}
        onChange={(next) => onChange(field.name, next)}
      />
    );
  }
  if (field.type === "boolean") {
    return <ListBooleanField field={field} value={value} onChange={onChange} />;
  }
  if (field.type === "icon") {
    return <ListIconField field={field} value={value} onChange={onChange} />;
  }
  if (field.type === "record" || field.type === "records") {
    return <ListRecordField field={field} value={value} onChange={onChange} />;
  }
  return (
    <div>
      <label className="block">
        <ListFieldTitle field={field} />
        <ListTextControl
          field={field}
          value={value}
          placeholder={placeholder}
          onInput={(event) => onChange(field.name, event.target.value)}
        />
      </label>
      <ListFieldHint id={field.hint} />
    </div>
  );
}

export default ListField;
